import Base from 'netxcore@netx/core-app/views/alertView';

import {faExclamationTriangle} from '@netx/core-icons';
const icons = Base.initializeIcons({
	faExclamationTriangle,
});

export default class AlertView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.icons = {...icons, ...opts.icons};
		super(opts);
	}
}
